import type { BrandCategoryKey } from './brandCategoryTypes'

export type { BrandCategoryKey } from './brandCategoryTypes'

export type BrandCategoryTile = {
  key: BrandCategoryKey
  preset: { q?: string }
}

/** Shop-by-brand grid — order matches brand logo sheet (4×3). */
export const BRAND_CATEGORY_TILES: BrandCategoryTile[] = [
  { key: 'apple', preset: { q: 'Apple' } },
  { key: 'samsung', preset: { q: 'Samsung' } },
  { key: 'google', preset: { q: 'Google' } },
  { key: 'oneplus', preset: { q: 'OnePlus' } },
  { key: 'motorola', preset: { q: 'Motorola' } },
  { key: 'sony', preset: { q: 'Sony' } },
  { key: 'xiaomi', preset: { q: 'Xiaomi' } },
  { key: 'nokia', preset: { q: 'Nokia' } },
  { key: 'honor', preset: { q: 'Honor' } },
  { key: 'asus', preset: { q: 'Asus' } },
  { key: 'huawei', preset: { q: 'Huawei' } },
]
